// src/layout/AppTopbar.tsx
import { classNames } from "primereact/utils";
import { Badge } from "primereact/badge";
import { BreadCrumb } from "primereact/breadcrumb";
import "primeicons/primeicons.css";

import {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
  useMemo,
} from "react";
import { AppTopbarRef } from "../../types/layout";
import { useNavigate, useLocation } from "react-router-dom";
import RouteConstant from "../../constants/route.constants";
import { useTranslation } from "react-i18next";
import i18n from "../../localisation/i18n";
import AuthService from "../../services/autentication/auth.service";
import { useAppSelector } from "../../redux/hooks";
import UserService from "../../services/user/user.service";
import RoleService from "../../services/role/role-service";
import { OverlayPanel } from "primereact/overlaypanel";
import { ExecutiveInfoDTO } from "../../models/CustomerExecutive/CustomerExecutive-model";
import CustomerExecutiveService from "../../services/CustomerExecutives/CustomerExecutivesservice";
import { Avatar } from "primereact/avatar";
import { Divider } from "primereact/divider";
import { Button } from "primereact/button";
import { Tooltip } from "primereact/tooltip";
import { Card } from "primereact/card";
import orderServices from "../../services/orders/orderservice";
import { Toast } from "primereact/toast";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import ProductService from "../../services/products/products.service";
import { ProductPriceExport } from "../admin/product-price-export";
import ProductStorageHelpers from "../../utils/product-local-storage-wrapper";
import axios from "axios";
import UserMenu from "../user-menu";
import { LayoutContext } from "./context/layoutcontext";
import { useContext } from "react";

import ProfileMenu from "../user-menu/profile-menu/ProfileMenu";
import { MenuRoutes } from "../user-menu/menu/routes";
import { ModuleType } from "../../types/enum";
import { Module } from "../../models/menu/menu.model";
import NewsService, { NewsData } from "../../services/news/news.service";
import NewsModal from "../news/news-modal";
import OrderService from "../../services/order/order.service";
import { usePageNavigation } from "../user-menu/menu/navigation";
import { MenuType } from "../../types/enum";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faShareFromSquare, faBuildingColumns } from "@fortawesome/free-solid-svg-icons";
import SalesOrderingMain from "../user-sales-ordering/sales-ordering-main";
import SideCartFlow from "../new-sidebar-cart/sidecart-main";
import DeliveryLocation from "../user-address/delivery-location";


const AppTopbar = forwardRef<AppTopbarRef>((props, ref) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  // const { navigationModule, setNavigationModule } = useContext(LayoutContext);


  // Auto-close cart panel on navigation
  useEffect(() => {
    setIsCartPanelOpen?.(false);
  }, [location]);
  const { navigationModule, setNavigationModule, isCartPanelOpen, setIsCartPanelOpen } = useContext(LayoutContext);



  const menubuttonRef: any = useRef(null);
  const topbarmenuRef: any = useRef(null);
  const topbarmenubuttonRef: any = useRef(null);
  const langMenu: any = useRef(null);
  const menuLeft: any = useRef(null);
  const searchDropdownRef: any = useRef(null);
  const isUserLoggedIn: boolean = AuthService.isUserLoggedIn();
  const count = useAppSelector((state) => state.counter);
  const [currentUser, setCurrentUser] = useState<any>(null);
  const [executiveInfo, setExecutiveInfo] = useState<ExecutiveInfoDTO | null>(
    null
  );
  const executiveOverlayRef = useRef<OverlayPanel | null>(null);
  const rewardOverlayRef = useRef<OverlayPanel | null>(null);
  const toastRef = useRef<Toast>(null);
  const [showWhatsAppModal, setShowWhatsAppModal] = useState(false);
  const [recipientPhone, setRecipientPhone] = useState("");
  const [isAdmin, setIsAdmin] = useState<boolean>(false);
  const [isMenuVisible, setIsMenuVisible] = useState<boolean>(false);
  const [isProfileMenuVisible, setIsProfileMenuVisible] = useState<boolean>(false);
  const [isSearchModalOpen, setIsSearchModalOpen] = useState(false);
  const [menuActiveModuleId, setMenuActiveModuleId] = useState<number | null>(null);
  const [logoutDialogVisible, setLogoutDialogVisible] = useState(false);
  const [newsVisible, setNewsVisible] = useState<boolean>(false);
  const [newsData, setNewsData] = useState<NewsData[]>([]);
  const [availableRewardPoints, setAvailableRewardPoints] = useState<number | null>(null);
  const [rewardToCurrencyRatio, setRewardToCurrencyRatio] = useState<number>(0);
  const [isMobileView, setIsMobileView] = useState(false);
  const [isMobileDesktopView, setIsMobileDesktopView] = useState(false);
  const [isExecutiveDialogOpen, setIsExecutiveDialogOpen] = useState(false);
  const [isRewardDialogOpen, setIsRewardDialogOpen] = useState(false);
  const [isCustomerUser, setIsCustomerUser] = useState(false);
  const navigateToPage = usePageNavigation();
  const [showSalesDialog, setShowSalesDialog] = useState(false);


  // Get menu data for filtering
  const { menuData: allModules } = MenuRoutes();

  // Filter modules
  const myAccountModule = useMemo(() =>
    allModules.find(m => m.moduleId === ModuleType.MyAccount) || null
    , [allModules]);

  const otherModules = useMemo(() =>
    allModules.filter(m => m.moduleId !== ModuleType.MyAccount)
    , [allModules]);

  const handleCallMeBack = async () => {
    if (currentUser?.userID) {
      try {
        await orderServices.sendWhatsAppTemplateMessage(
          currentUser.userID,
          "callback_dual_notification"
        );

        toastRef.current?.show({
          severity: "success",
          summary: "Request Sent",
          detail: "Call Me Back request has been initiated.",
          life: 3000,
        });
      } catch (error) {
        if (axios.isAxiosError(error)) {
          const errorMessage = error.response?.data;

          if (
            typeof errorMessage === "string" &&
            errorMessage.includes("Executive mapping not found")
          ) {
            toastRef.current?.show({
              severity: "warn",
              summary: "Request Failed",
              detail: "No executive assigned to your account.",
              life: 3000,
            });
          } else {
            toastRef.current?.show({
              severity: "error",
              summary: "Error",
              detail: "Something went wrong while sending the request.",
              life: 3000,
            });
          }
        } else {
          toastRef.current?.show({
            severity: "error",
            summary: "Unexpected Error",
            detail: "An unknown error occurred.",
            life: 3000,
          });
        }
      }
    } else {
      toastRef.current?.show({
        severity: "warn",
        summary: "Missing Info",
        detail: "Unable to initiate request. User ID not found.",
        life: 3000,
      });
    }
  };

  const handleProductPriceExport = async () => {
    try {
      let productsArray: any[] = [];

      if (isAdmin) {
        const response = await ProductService.getAllAdminProducts();
        productsArray = Array.isArray(response) ? response : (response?.data || []);
      } else if (ProductStorageHelpers.GetUserId()) {
        productsArray = await ProductService.getAllProducts1();
      } else {
        productsArray = await ProductService.getAllProducts();
      }

      if (productsArray.length === 0) {
        console.warn("No products available to export.");
        toastRef.current?.show({
          severity: "warn",
          summary: "No Products",
          detail: "No products available to export.",
          life: 3000,
        });
        return;
      }

      ProductPriceExport(productsArray);
      toastRef.current?.show({
        severity: "success",
        summary: "Export Successful",
        detail: "Product list exported successfully!",
        life: 3000,
      });
    } catch (error) {
      console.error("Error exporting product price:", error);
      toastRef.current?.show({
        severity: "error",
        summary: "Export Failed",
        detail: "Failed to export product list.",
        life: 3000,
      });
    }
  };

  const handleWhatsAppReferral = async () => {
    try {
      const senderUserId = ProductStorageHelpers.GetUserId() || 0;
      const productsArray = await ProductService.getAllProducts1();
      const pdfBlob = await ProductPriceExport(productsArray);
      const pdfFile = new File([pdfBlob], "Product_list.pdf", {
        type: "application/pdf",
      });

      const formData = new FormData();
      formData.append("pdf", pdfFile);

      const BASE_URL =
        process.env.REACT_APP_SERVER_ENDPOINT?.replace(/\/$/, "") || "";

      const uploadResponse = await fetch(
        `${BASE_URL}/api/whatsapp/upload-pdf`,
        {
          method: "POST",
          body: formData,
        }
      );

      if (!uploadResponse.ok) {
        throw new Error("Upload failed");
      }

      const { fileUrl: pdfUrl } = await uploadResponse.json();

      const encodedUrl = encodeURIComponent(pdfUrl);
      const messageType = `product_price_list_referral|${recipientPhone}|${encodedUrl}`;

      await orderServices.sendWhatsAppTemplateMessage(
        senderUserId,
        messageType
      );

      toastRef.current?.show({
        severity: "success",
        summary: "Message Sent",
        detail: "WhatsApp message sent successfully!",
        life: 3000,
      });

      setTimeout(() => setShowWhatsAppModal(false), 100);
      setRecipientPhone("");
    } catch (error) {
      console.error("Error sending WhatsApp referral:", error);
      toastRef.current?.show({
        severity: "error",
        summary: "Send Failed",
        detail: "Failed to send WhatsApp message.",
        life: 3000,
      });
    }
  };

  useEffect(() => {
    const adminCheck = ProductStorageHelpers.IsAdminUser();
    setIsAdmin(adminCheck);
  }, []);

  useEffect(() => {
    setIsCustomerUser(RoleService.isCustomer());
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      if (AuthService.isUserLoggedIn()) {
        const user = await UserService.getCurrentUser();
        setCurrentUser(user);
      }
    };
    fetchData();
  }, []);

  const normalize = (p: string) => (p || "").replace(/\/+$/, "");
  const EXEC_SELECTED_CUSTOMER_KEY = "selectedCustomerExecutiveUserId";

  const getSelectedCustomerId = () => {
    const raw = localStorage.getItem(EXEC_SELECTED_CUSTOMER_KEY);
    const id = raw ? Number(raw) : NaN;
    return Number.isFinite(id) && id > 0 ? id : null;
  };

  const isHomePage =
    normalize(location.pathname) === normalize(RouteConstant.products);
  const isCartPage =
    normalize(location.pathname) === normalize(RouteConstant.basket);

  useEffect(() => {
    const fetchExecutiveInfo = async () => {
      if (!AuthService.isUserLoggedIn()) {
        setExecutiveInfo(null);
        return;
      }

      const selectedCustomerId = getSelectedCustomerId();
      if (RoleService.isCustomer()) {
        const info = await CustomerExecutiveService.getAssignedExecutive(
          currentUser?.userID
        );
        setExecutiveInfo(info);
      } else if (selectedCustomerId) {
        const info = await CustomerExecutiveService.getAssignedExecutive(
          selectedCustomerId
        );
        setExecutiveInfo(info);
      } else {
        setExecutiveInfo(null);
      }
    };

    fetchExecutiveInfo();

    const handleSelectionChange = () => {
      fetchExecutiveInfo();
    };

    window.addEventListener("executive-customer-selected", handleSelectionChange);
    window.addEventListener("storage", handleSelectionChange);

    return () => {
      window.removeEventListener("executive-customer-selected", handleSelectionChange);
      window.removeEventListener("storage", handleSelectionChange);
    };
  }, [location.pathname, currentUser?.userID]);

  useEffect(() => {
    const fetchBalance = () => {
      if (!currentUser?.userID) return;
      OrderService.getUserRewardBalance(currentUser.userID)
        .then((res: any) => {
          setAvailableRewardPoints(res?.availablePoints ?? 0);
          setRewardToCurrencyRatio(res?.rewardToCurrencyRatio ?? 0);
        })
        .catch(() => {
          setAvailableRewardPoints(null);
          setRewardToCurrencyRatio(0);
        });
    };

    fetchBalance();

    window.addEventListener('refresh-rewards', fetchBalance);
    return () => window.removeEventListener('refresh-rewards', fetchBalance);
  }, [currentUser?.userID]);

  const itemsLang = [
    { label: "English", command: () => i18n.changeLanguage("en") },
    { label: "عربی", command: () => i18n.changeLanguage("ar") },
    { label: "ಕನ್ನಡ", command: () => i18n.changeLanguage("kn") },
    { label: "हिंदी", command: () => i18n.changeLanguage("hn") },
  ];

  useEffect(() => {
    const handleDocumentClick = (e: any) => {
      try {
        if (
          topbarmenuRef.current &&
          !topbarmenuRef.current.contains(e.target)
        ) {
          setIsMenuVisible(false);
        }
        if (
          topbarmenubuttonRef.current &&
          topbarmenubuttonRef.current.contains(e.target)
        ) {
          setIsMenuVisible(!isMenuVisible);
        }
      } catch (ex: any) {
        console.error(ex);
      }
    };

    document.addEventListener("click", handleDocumentClick);
    return () => {
      document.removeEventListener("click", handleDocumentClick);
    };
  }, [isMenuVisible]);

  useImperativeHandle(ref, () => ({
    menubutton: menubuttonRef.current,
    topbarmenu: topbarmenuRef.current,
    topbarmenubutton: topbarmenubuttonRef.current,
  }));

  const [searchQuery, setSearchQuery] = useState("");
  const [animate, setAnimate] = useState(false);

  useEffect(() => {
    if (count > 0) {
      setAnimate(true);
      const timer = setTimeout(() => setAnimate(false), 1000);
      return () => clearTimeout(timer);
    }
  }, [count]);

  useEffect(() => {
    if (typeof window === "undefined") return;
    const media = window.matchMedia("(max-width: 768px)");
    const handleChange = () => setIsMobileView(media.matches);
    handleChange();
    if (media.addEventListener) {
      media.addEventListener("change", handleChange);
    } else {
      media.addListener(handleChange);
    }
    return () => {
      if (media.removeEventListener) {
        media.removeEventListener("change", handleChange);
      } else {
        media.removeListener(handleChange);
      }
    };
  }, []);

  // Detect desktop site on mobile devices
  useEffect(() => {
    if (typeof window === "undefined") return;

    const checkMobileDesktopView = () => {
      const isTouch =
        'ontouchstart' in window ||
        navigator.maxTouchPoints > 0 ||
        window.matchMedia('(pointer: coarse)').matches;

      const isMobileUA = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      );

      const isIOSDesktopSite =
        navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1;

      const minScreenDim = Math.min(
        window.screen?.width || 9999,
        window.screen?.height || 9999
      );
      const isPhonePhysicalScreen = minScreenDim <= 768;

      const isDesktopViewport = window.innerWidth >= 768;

      const isMobileDevice =
        isMobileUA || isIOSDesktopSite || (isTouch && isPhonePhysicalScreen);

      const urlParams = new URLSearchParams(window.location.search);
      const forcedMobileDesktop = urlParams.get('mobileDesktop') === 'true';

      const isDesktopOnMobile = forcedMobileDesktop || (isDesktopViewport && isMobileDevice);

      setIsMobileDesktopView(isDesktopOnMobile);
      if (document?.body) {
        document.body.classList.toggle('mobile-desktop-view', isDesktopOnMobile);
      }
    };

    checkMobileDesktopView();
    window.addEventListener('resize', checkMobileDesktopView);
    window.addEventListener('orientationchange', checkMobileDesktopView);

    return () => {
      window.removeEventListener('resize', checkMobileDesktopView);
      window.removeEventListener('orientationchange', checkMobileDesktopView);
      if (document?.body) {
        document.body.classList.remove('mobile-desktop-view');
      }
    };
  }, []);

  // Handle click outside search dropdown to close it
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        searchDropdownRef.current &&
        !searchDropdownRef.current.contains(event.target) &&
        !(event.target as HTMLElement).closest(".topbar-search-icon-btn")
      ) {
        setIsSearchModalOpen(false);
      }
    };

    if (isSearchModalOpen) {
      document.addEventListener("click", handleClickOutside);
      return () => document.removeEventListener("click", handleClickOutside);
    }
  }, [isSearchModalOpen]);

  // Watch for breadcrumb click to open menu with module
  useEffect(() => {
    if (navigationModule !== null && navigationModule !== undefined) {
      if (navigationModule === ModuleType.MyAccount) {
        setIsProfileMenuVisible(true);
      } else {
        setIsMenuVisible(true);
        setMenuActiveModuleId(navigationModule);
      }

      // Reset the navigation module after opening
      if (setNavigationModule) {
        setNavigationModule(null);
      }
    }
  }, [navigationModule, setNavigationModule]);

  // Load News data from API
  const fetchNewsData = async () => {
    try {
      const data = await NewsService.getNewsData();
      setNewsData(data);
    } catch (error) {
      console.error("Error loading news data:", error);
    }
  };

  const handleNewsButtonClick = async () => {
    await fetchNewsData();
    setNewsVisible(true);
  };
  const handleNewsHide = () => {
    setNewsVisible(false);
  };

  const whatsappDialogHeader = (
    <div style={{ width: "100%" }}>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "0.9rem",
          padding: "0.25rem 0 0.85rem",
        }}
      >
        <div
          style={{
            width: "3rem",
            height: "3rem",
            borderRadius: "0.9rem",
            background: "linear-gradient(135deg, #e8fff1 0%, #d9fbe8 100%)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: "#25D366",
            fontSize: "1.35rem",
            boxShadow: "inset 0 0 0 1px rgba(37, 211, 102, 0.18)",
          }}
        >
          <i className="pi pi-whatsapp" />
        </div>
        <div>
          <div
            style={{
              fontSize: "1.2rem",
              fontWeight: 700,
              color: "#1f2937",
              lineHeight: 1.2,
            }}
          >
            Share Brochure
          </div>
        </div>
      </div>
      <div
        style={{
          width: "100%",
          borderBottom: "1px solid #d9dee3",
        }}
      />
    </div>
  );

  const whatsappDialogFooter = (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: "1rem",
        width: "100%",
        flexWrap: "wrap",
      }}
    >
      <div
        style={{
          fontSize: "0.78rem",
          color: "#6b7280",
          display: "flex",
          alignItems: "center",
          gap: "0.4rem",
        }}
      >
        <svg
          width="21"
          height="21"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true"
          style={{ color: "#25D366", flexShrink: 0 }}
        >
          <path
            d="M7 2.75C7 2.33579 7.33579 2 7.75 2H14.35C14.5489 2 14.7397 2.07902 14.8803 2.21967L19.7803 7.11967C19.921 7.26032 20 7.45109 20 7.65V19.75C20 20.1642 19.6642 20.5 19.25 20.5H7.75C7.33579 20.5 7 20.1642 7 19.75V2.75Z"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M14.5 2.5V7.1C14.5 7.54183 14.8582 7.9 15.3 7.9H19.9"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M9.3 16.75C10.25 15.95 11.45 14.1 12.25 12.05C12.65 11.03 12.88 10.14 12.9 9.42C12.92 8.78 12.72 8.3 12.32 8.25C11.88 8.2 11.56 8.62 11.52 9.32C11.46 10.44 11.88 12.1 12.78 13.67C13.66 15.2 14.68 16.15 15.62 16.22C16.13 16.26 16.5 16.04 16.54 15.64C16.59 15.12 16.03 14.78 15.11 14.7C13.77 14.59 11.92 15.08 10.39 15.78C9.03 16.4 8.06 17.16 7.56 17.82C7.25 18.22 7.17 18.6 7.38 18.83C7.62 19.09 8.05 18.98 8.54 18.57C9.47 17.8 10.7 16.08 11.48 14.54C12.38 12.77 13.02 10.67 13 9.04"
            stroke="currentColor"
            strokeWidth="1.15"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
        Latest PDF will be shared securely
      </div>

      <div
        style={{
          width: "100%",
          borderTop: "1px solid #d9dee3",
          marginTop: "0.2rem",
          paddingTop: "1rem",
          display: "flex",
          gap: "0.75rem",
          justifyContent: "flex-end",
        }}
      >
        <Button
          label="Cancel"
          className="p-button-text"
          onClick={() => setShowWhatsAppModal(false)}
          style={{
            color: "#6b7280",
            padding: "0.65rem 1rem",
          }}
        />
        <Button
          label="Send on WhatsApp"
          icon="pi pi-whatsapp"
          onClick={() => handleWhatsAppReferral()}
          disabled={!recipientPhone || recipientPhone.length !== 10}
          style={{
            background: "linear-gradient(135deg, #25D366 0%, #169c4f 100%)",
            border: "none",
            borderRadius: "999px",
            padding: "0.75rem 1.15rem",
            fontWeight: 600,
            boxShadow: "0 10px 24px rgba(37, 211, 102, 0.22)",
          }}
        />
      </div>
    </div>
  );


  return (
    <>
      <Toast ref={toastRef} />

      <div className="layout-topbar">
        {/* Logo */}
        <div
          className="layout-topbar-logo"
          onClick={() => {
            navigate(RouteConstant.products);
          }}
        >
          <img
            src={process.env.PUBLIC_URL + "/assests/images/logo.png"}
            alt="Farm2Me"
          />
        </div>

        <div className="layout-topbar-right">
          <DeliveryLocation />
          {/* Action Buttons - Export, WhatsApp, Call Executive */}
          {/* Action Buttons */}
          <div className="topbar-action-buttons">

            {isUserLoggedIn && isAdmin && (
              <Button
                className="sales-btn"
                style={{
                  background: 'linear-gradient(135deg, #40a344ff 0%, #75b64dff 100%)',
                  border: 'none',
                  marginLeft: '0.5rem',
                  marginRight: '0.5rem',
                  borderRadius: '8px',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center',
                  height: '42px',
                  minWidth: '44px',
                  padding: '0.15rem'
                }}
                onClick={() => setShowSalesDialog(true)}
                tooltip="Create Sales Order"
                tooltipOptions={{ position: "bottom" }}
              >
                <FontAwesomeIcon
                  icon={faBuildingColumns}
                  style={{ fontSize: '0.8rem', color: '#ffffff', marginBottom: '2px' }}
                />
                <span className="p-button-label" style={{ display: 'block', fontSize: '0.65rem', fontWeight: 700, color: '#ffffff', textTransform: 'lowercase', letterSpacing: '0.05em', lineHeight: 1 }}>Sales</span>
              </Button>
            )}

            {/* Product Broucher pill: label + download + share */}
            <div className="product-broucher-group">
              <span className="product-broucher-label">Product Broucher</span>

              <Button
                icon="pi pi-download"
                className="product-broucher-btn"
                onClick={handleProductPriceExport}
                tooltip="Download Product Broucher"
                tooltipOptions={{ position: "bottom" }}
              />

              <Button
                className="product-broucher-btn"
                onClick={() => setShowWhatsAppModal(true)}
                tooltip="Share Broucher via WhatsApp"
                tooltipOptions={{ position: "bottom" }}
              >
                <i className="pi pi-whatsapp" />
              </Button>
            </div>

            {/* Call Executive */}
            {isUserLoggedIn && (
              <Button
                icon="pi pi-phone"
                className="call-executive-btn"
                onClick={(e) => {
                  if (isMobileView) {
                    setIsExecutiveDialogOpen(true);
                  } else {
                    executiveOverlayRef.current?.toggle(e);
                  }
                }}
                tooltip="Call Executive"
                tooltipOptions={{ position: "bottom" }}
              />
            )}

            {/* News Icon Button */}
            <Button
              icon="pi pi-book"
              className="news-btn"
              onClick={handleNewsButtonClick}
              tooltip="View News"
              tooltipOptions={{ position: "bottom" }}
            />

          </div>


          {/* Home icon - Visible when not on home page */}
          {!isHomePage && (
            <button
              className="topbar-icon-btn topbar-home-btn"
              onClick={() => {
                navigate(RouteConstant.products);
              }}
              aria-label="Home"
              title="Back to Home"
            >
              <i className="pi pi-home" />
            </button>
          )}

          {/* Search - Home page only */}
          {isHomePage && (
            <>
              {/* Search Bar - Desktop */}
              <div className="topbar-search topbar-search-desktop">
                <i className="pi pi-search" />
                <input
                  type="text"
                  placeholder="Search products..."
                  value={searchQuery}
                  onChange={(e) => {
                    const query = e.target.value;
                    setSearchQuery(query);
                    if (query.trim()) {
                      navigate(
                        `${RouteConstant.products}?search=${encodeURIComponent(
                          query
                        )}`
                      );
                    } else {
                      navigate(RouteConstant.products);
                    }
                  }}
                  onKeyDown={(e) => {
                    if (e.key === "Escape") {
                      setSearchQuery("");
                      navigate(RouteConstant.products);
                    }
                    // Navigate to home when search is cleared via backspace
                    if (e.key === "Backspace" && searchQuery.length === 1) {
                      setTimeout(() => {
                        setSearchQuery("");
                        navigate(RouteConstant.products);
                      }, 100);
                    }
                  }}
                />
                {searchQuery && (
                  <button
                    className="topbar-search-clear-btn"
                    onClick={() => {
                      setSearchQuery("");
                      navigate(RouteConstant.products);
                    }}
                    aria-label="Clear search"
                    type="button"
                  >
                    <i className="pi pi-times" />
                  </button>
                )}
              </div>

              {/* Search Icon Button - Mobile */}
              <button
                className="topbar-icon-btn topbar-search-icon-btn"
                onClick={() => setIsSearchModalOpen(true)}
                aria-label="Search"
                title="Search products"
              >
                <i className="pi pi-search" />
              </button>
            </>
          )}

          {/* Reward Points Badge - desktop only, customer users only */}
          {isUserLoggedIn &&
            !isMobileView &&
            isCustomerUser &&
            availableRewardPoints !== null &&
            (isHomePage || isCartPage) && (
              <>
                <div
                  className="topbar-reward-badge"
                  onClick={(e) => {
                    if (isMobileView) {
                      setIsRewardDialogOpen(true);
                    } else {
                      rewardOverlayRef.current?.toggle(e);
                    }
                  }}
                  role="button"
                  aria-label="View reward points"
                >
                  <span className="reward-coin-icon">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                      <circle cx="8" cy="8" r="6"></circle>
                      <path d="M18.09 10.37A6 6 0 1 1 10.34 18"></path>
                      <path d="M7 6h1v4"></path>
                      <path d="m16.71 13.88.7.71-2.82 2.82"></path>
                    </svg>
                  </span>
                  <span className="reward-points-value">{availableRewardPoints.toLocaleString()}</span>
                  <span className="reward-chevron">
                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                      <path d="m18 15-6-6-6 6" />
                    </svg>
                  </span>
                </div>
              </>
            )}

          {/* Cart - Always visible but styled differently for mobile */}
          {/* <button
            className="topbar-icon-btn topbar-cart-btn"
            onClick={() => navigate(RouteConstant.basket)}
            aria-label="Cart"
          >
            <i className={`pi pi-shopping-cart ${animate ? "zoomin" : ""}`} />
            {count > 0 && <Badge value={count} severity="danger" />}
          </button> */}

          <button
            className="topbar-icon-btn topbar-cart-btn"
            onClick={() => {
              console.log("🛒 Cart button clicked");
              setIsCartPanelOpen?.(true);
            }}
          >
            <i className="pi pi-shopping-cart" />
            {count > 0 && <Badge value={count} severity="danger" />}
          </button>

          {/* Mobile-only reward in menu slot for customer users (home & cart only) */}
          {isUserLoggedIn && isMobileView && isCustomerUser && (isHomePage || isCartPage) && (
            <div
              className="topbar-reward-badge mobile-reward-slot"
              onClick={(e) => {
                if (isMobileView) {
                  setIsRewardDialogOpen(true);
                } else {
                  rewardOverlayRef.current?.toggle(e);
                }
              }}
              role="button"
              aria-label="View reward points"
            >
              <span className="reward-coin-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                  <circle cx="8" cy="8" r="6"></circle>
                  <path d="M18.09 10.37A6 6 0 1 1 10.34 18"></path>
                  <path d="M7 6h1v4"></path>
                  <path d="m16.71 13.88.7.71-2.82 2.82"></path>
                </svg>
              </span>
              <span className="reward-points-value">{(availableRewardPoints ?? 0).toLocaleString()}</span>
              <span className="reward-chevron">
                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                  <path d="m18 15-6-6-6 6" />
                </svg>
              </span>
            </div>
          )}

          {/* Menu - Only show if there are modules other than MyAccount */}
          {isUserLoggedIn && otherModules.length > 0 && (
            (isMobileView && isCustomerUser) ? null : (
              <UserMenu
                isOpen={isMenuVisible}
                onOpenChange={setIsMenuVisible}
                activeModuleId={menuActiveModuleId}
                onActiveModuleChange={setMenuActiveModuleId}
              />
            )
          )}

          {/* Login / Account */}
          {!isUserLoggedIn ? (
            <button
              className="topbar-login-btn"
              onClick={() => navigate(RouteConstant.login)}
            >
              <i className="pi pi-sign-in" />
              <span>Login</span>
            </button>
          ) : (
            <ProfileMenu
              currentUser={currentUser}
              myAccountModule={myAccountModule}
              onLogout={() => {
                AuthService.logout();
                setTimeout(() => navigate(RouteConstant.login), 80);
              }}
              isOpen={isProfileMenuVisible}
              onOpenChange={setIsProfileMenuVisible}
              onDownloadBroucher={handleProductPriceExport}
              onShareWhatsApp={() => setShowWhatsAppModal(true)}
              onViewNews={handleNewsButtonClick}
              onCallExecutive={() => setIsExecutiveDialogOpen(true)}
              isAdmin={isAdmin}
              isUserLoggedIn={isUserLoggedIn}
              isMobileDesktopView={isMobileDesktopView}
            />
          )}
        </div>
      </div>

      {/* Mobile Footer - Header icons (except menu/profile) */}
      <div className="layout-mobile-footer">
        <div className="mobile-footer-actions">
          {/* Call Executive */}
          {isUserLoggedIn && (
            <Button
              icon="pi pi-phone"
              className="call-executive-btn"
              onClick={(e) => {
                if (isMobileView) {
                  setIsExecutiveDialogOpen(true);
                } else {
                  executiveOverlayRef.current?.toggle(e);
                }
              }}
              tooltip="Call Executive"
              tooltipOptions={{ position: "top" }}
            />
          )}

          {/* Home icon */}
          {!isHomePage && (
            <button
              className="topbar-icon-btn topbar-home-btn"
              onClick={() => {
                navigate(RouteConstant.products);
              }}
              aria-label="Home"
              title="Back to Home"
            >
              <i className="pi pi-home" />
            </button>
          )}

          {/* Search Icon Button */}
          {isHomePage && (
            <button
              className="topbar-icon-btn topbar-search-icon-btn"
              onClick={() => setIsSearchModalOpen(true)}
              aria-label="Search"
              title="Search products"
            >
              <i className="pi pi-search" />
            </button>
          )}

          {/* Reward Points Badge (home & cart only) - Customer only */}
          {isUserLoggedIn && availableRewardPoints !== null && isCustomerUser && (isHomePage || isCartPage) && (
            <div
              className="topbar-reward-badge"
              onClick={(e) => {
                if (isMobileView) {
                  setIsRewardDialogOpen(true);
                } else {
                  rewardOverlayRef.current?.toggle(e);
                }
              }}
              role="button"
              aria-label="View reward points"
            >
              <span className="reward-coin-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                  <circle cx="8" cy="8" r="6"></circle>
                  <path d="M18.09 10.37A6 6 0 1 1 10.34 18"></path>
                  <path d="M7 6h1v4"></path>
                  <path d="m16.71 13.88.7.71-2.82 2.82"></path>
                </svg>
              </span>
              <span className="reward-points-value">{availableRewardPoints.toLocaleString()}</span>
              <span className="reward-chevron">
                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                  <path d="m18 15-6-6-6 6" />
                </svg>
              </span>
            </div>
          )}

          {/* Sales Icon for Admins (Replacing rewards slot in footer - HIGHLIGHTED) */}
          {isUserLoggedIn && isAdmin && (isHomePage || isCartPage) && (
            <div className="mobile-sales-highlight-wrapper" style={{ position: 'relative' }}>
              <button
                className="topbar-icon-btn sales-mobile-btn highlighted-sales-btn"
                onClick={() => setShowSalesDialog(true)}
                aria-label="Sales"
                title="Create Sales Order"
                style={{
                  background: 'linear-gradient(135deg, #40a344 0%, #75b64d 100%)',
                  color: 'white',
                  borderRadius: '10px',
                  width: '38px',
                  height: '38px',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center',
                  border: '2px solid #ffffff',
                  boxShadow: '0 8px 16px rgba(64, 163, 68, 0.35)',
                  position: 'relative',
                  zIndex: 2,
                  animation: 'pulse-green 2.5s infinite',
                  padding: '0'
                }}
              >
                <FontAwesomeIcon
                  icon={faBuildingColumns}
                  style={{ fontSize: '0.72rem', color: '#ffffff', marginBottom: '1px', flex: 'none' }}
                />
                <span style={{ display: 'block', fontSize: '0.44rem', fontWeight: 600, color: '#ffffff', textTransform: 'lowercase', letterSpacing: '0.04em', lineHeight: 1, flex: 'none' }}>Sales</span>
              </button>

              {/* Pulsing background ripple effect */}
              <div style={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                width: '38px',
                height: '38px',
                borderRadius: '10px',
                background: 'rgba(64, 163, 68, 0.3)',
                zIndex: 1,
                animation: 'ripple-green 2.5s infinite'
              }}></div>

              <style>{`
                @keyframes pulse-green {
                  0% { transform: scale(1); }
                  50% { transform: scale(1.08); }
                  100% { transform: scale(1); }
                }
                @keyframes ripple-green {
                  0% { transform: translate(-50%, -50%) scale(1); opacity: 0.8; }
                  100% { transform: translate(-50%, -50%) scale(1.6); opacity: 0; }
                }
              `}</style>
            </div>
          )}

          {/* Mobile-only: brochure actions inside footer (customer only) */}
          {isUserLoggedIn && isHomePage && isCustomerUser && (
            <>
              <button
                className="topbar-icon-btn mobile-footer-plain-btn"
                onClick={handleProductPriceExport}
                aria-label="Download product brochure"
                title="Download Product Brochure"
                type="button"
              >
                <i className="pi pi-download" />
              </button>
              <button
                className="topbar-icon-btn mobile-footer-plain-btn"
                onClick={() => setShowWhatsAppModal(true)}
                aria-label="Share brochure via WhatsApp"
                title="Share Brochure via WhatsApp"
                type="button"
              >
                <i className="pi pi-whatsapp" />
              </button>
              <button
                className="topbar-icon-btn mobile-footer-plain-btn"
                onClick={handleNewsButtonClick}
                aria-label="View news"
                title="View News"
                type="button"
              >
                <i className="pi pi-book" />
              </button>
            </>
          )}

          {/* Mobile-only: brochure actions inside footer (admin/super admin) */}
          {isUserLoggedIn && isHomePage && !isCustomerUser && (
            <>
              <button
                className="topbar-icon-btn mobile-footer-plain-btn"
                onClick={handleProductPriceExport}
                aria-label="Download product brochure"
                title="Download Product Brochure"
                type="button"
              >
                <i className="pi pi-download" />
              </button>
              <button
                className="topbar-icon-btn mobile-footer-plain-btn"
                onClick={() => setShowWhatsAppModal(true)}
                aria-label="Share brochure via WhatsApp"
                title="Share Brochure via WhatsApp"
                type="button"
              >
                <i className="pi pi-whatsapp" />
              </button>
              <button
                className="topbar-icon-btn mobile-footer-plain-btn"
                onClick={handleNewsButtonClick}
                aria-label="View news"
                title="View News"
                type="button"
              >
                <i className="pi pi-book" />
              </button>
            </>
          )}

          {/* Cart */}
          <button
            className="topbar-icon-btn topbar-cart-btn"
            onClick={() => navigate(RouteConstant.basket)}
            aria-label="Cart"
          >
            <i className={`pi pi-shopping-cart ${animate ? "zoomin" : ""}`} />
            {count > 0 && <Badge value={count} severity="danger" />}
          </button>
        </div>
      </div>

      {/* Mobile floating brochure buttons (above footer) - Home only */}
      {isHomePage && !isMobileView && !isMenuVisible && (
        <div className="mobile-broucher-fixed" aria-label="Product brochure actions">
          <Button
            icon="pi pi-download"
            className="mobile-broucher-fixed-btn"
            onClick={handleProductPriceExport}
            tooltip="Download Product Broucher"
            tooltipOptions={{ position: "top" }}
          />
          <Button
            icon="pi pi-whatsapp"
            className="mobile-broucher-fixed-btn"
            onClick={() => setShowWhatsAppModal(true)}
            tooltip="Share Broucher via WhatsApp"
            tooltipOptions={{ position: "top" }}
          />
          <Button
            icon="pi pi-book"
            className="mobile-broucher-fixed-btn"
            onClick={handleNewsButtonClick}
            tooltip="View News"
            tooltipOptions={{ position: "top" }}
          />
        </div>
      )}

      {/* Executive Info Overlay */}
      <OverlayPanel
        ref={executiveOverlayRef}
        className="executive-overlay-panel"
        style={{ width: "250px" }}
      >
        <div className="executive-overlay-content">
          <button
            className="executive-overlay-close"
            type="button"
            aria-label="Close"
            onClick={() => executiveOverlayRef.current?.hide()}
          >
            <i className="pi pi-times" />
          </button>
          {executiveInfo ? (
            <Card className="text-center surface-100 border-round shadow-2">
              <div className="flex flex-column align-items-center gap-1">
                <Avatar
                  icon="pi pi-user"
                  size="large"
                  className="bg-blue-80 text-blue-500"
                  shape="circle"
                />
                <div className="mt-2 text-xl font-semibold text-gray-900">
                  {executiveInfo.executiveName}
                </div>
                <div className="text-sm text-gray-500">Sales Advisor</div>
                <Divider className="my-2 w-10" />
                <div className="flex align-items-center gap-2">
                  <i className="pi pi-phone text-green-700" />
                  <a
                    href={`tel:${executiveInfo.executivePhoneNumber}`}
                    className="text-primary font-semibold no-underline"
                  >
                    {executiveInfo.executivePhoneNumber}
                  </a>
                </div>
                <Button
                  icon="pi pi-bell"
                  label="Call Me Back"
                  className="mt-3 p-button-sm p-button-text p-button-warning"
                  onClick={handleCallMeBack}
                />
              </div>
            </Card>
          ) : (
            <Card className="p-3 text-center surface-100 border-round shadow-2">
              <div className="text-gray-500 italic">
                No executive assigned yet
              </div>
            </Card>
          )}
        </div>
      </OverlayPanel>

      {isMobileView && (
        <Dialog
          visible={isExecutiveDialogOpen}
          className="executive-dialog"
          style={{ width: "90vw", maxWidth: "320px" }}
          onHide={() => setIsExecutiveDialogOpen(false)}
          dismissableMask
          showHeader={false}
          contentStyle={{ padding: 0, background: "transparent", overflow: "visible" }}
        >
          <div className="executive-overlay-content">
            <button
              className="executive-overlay-close"
              type="button"
              aria-label="Close"
              onClick={() => setIsExecutiveDialogOpen(false)}
            >
              <i className="pi pi-times" />
            </button>
            {executiveInfo ? (
              <Card className="text-center surface-100 border-round shadow-2">
                <div className="flex flex-column align-items-center gap-1">
                  <Avatar
                    icon="pi pi-user"
                    size="large"
                    className="bg-blue-80 text-blue-500"
                    shape="circle"
                  />
                  <div className="mt-2 text-xl font-semibold text-gray-900">
                    {executiveInfo.executiveName}
                  </div>
                  <div className="text-sm text-gray-500">Sales Advisor</div>
                  <Divider className="my-2 w-10" />
                  <div className="flex align-items-center gap-2">
                    <i className="pi pi-phone text-green-700" />
                    <a
                      href={`tel:${executiveInfo.executivePhoneNumber}`}
                      className="text-primary font-semibold no-underline"
                    >
                      {executiveInfo.executivePhoneNumber}
                    </a>
                  </div>
                  <Button
                    icon="pi pi-bell"
                    label="Call Me Back"
                    className="mt-3 p-button-sm p-button-text p-button-warning"
                    onClick={handleCallMeBack}
                  />
                </div>
              </Card>
            ) : (
              <Card className="p-3 text-center surface-100 border-round shadow-2">
                <div className="text-gray-500 italic">
                  No executive assigned yet
                </div>
              </Card>
            )}
          </div>
        </Dialog>
      )}

      {/* Reward Points Overlay */}
      {availableRewardPoints !== null && (() => {
        const pts = availableRewardPoints;
        const radius = 28; const circ = 2 * Math.PI * radius;

        const rewardBody = (
          <>
            {/* Header — Light Green Gradient Theme */}
            <div style={{ background: 'linear-gradient(135deg, #f1f8e9 0%, #dcedc8 100%)', padding: '1.25rem 1.25rem 1rem', color: '#333' }}>
              {/* Member tier label */}
              <div style={{ display: 'flex', alignItems: 'center', gap: '0.25rem' }}>
                {/* Circular progress ring with coins icon inside */}
                <div style={{ flexShrink: 0 }}>
                  <svg width="72" height="72" viewBox="0 0 72 72">
                    <defs>
                      <linearGradient id="overlayCoinGrad" x1="0%" y1="0%" x2="100%" y2="100%">
                        <stop offset="0%" stopColor="#fcd34d" />
                        <stop offset="100%" stopColor="#f59e0b" />
                      </linearGradient>
                    </defs>
                    <circle cx="36" cy="36" r={radius} fill="none" stroke="rgba(107, 168, 62, 0.2)" strokeWidth="5" />
                    <circle cx="36" cy="36" r={radius} fill="none" stroke="#6ba83e" strokeWidth="5"
                      strokeDashoffset={circ / 4}
                      strokeLinecap="round"
                      style={{ transition: 'stroke-dasharray 0.6s ease' }} />
                    <circle cx="36" cy="36" r="14" fill="url(#overlayCoinGrad)" stroke="#fef3c7" strokeWidth="2" />
                    <g transform="translate(27, 27) scale(0.75)" stroke="#ffffff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="none">
                      <circle cx="8" cy="8" r="6" />
                      <path d="M18.09 10.37A6 6 0 1 1 10.34 18" />
                      <path d="M7 6h1v4" />
                      <path d="m16.71 13.88.7.71-2.82 2.82" />
                    </g>
                  </svg>
                </div>

                <div style={{ flex: 1, textAlign: 'left', marginLeft: '-0.15rem', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                  <div>
                    <span style={{ fontSize: '2.2rem', fontWeight: 800, lineHeight: 1, color: '#333' }}>{pts.toLocaleString()}</span>
                    <span style={{ fontSize: '0.85rem', color: '#666', marginLeft: '0.35rem', fontWeight: 500 }}>POINTS</span>
                  </div>
                  {rewardToCurrencyRatio > 0 && (
                    <div style={{ fontSize: '0.85rem', color: '#2e7d32', fontWeight: 600, marginTop: '0.3rem' }}>
                      1 Point = {rewardToCurrencyRatio} Rs
                    </div>
                  )}
                </div>
              </div>

              {/* Tier progress pill — always visible */}
              <div
                style={{ marginTop: '0.75rem', background: '#f4faed', border: '1px solid #dcebda', borderRadius: '8px', padding: '0.5rem 0.75rem', display: 'flex', justifyContent: 'space-between', alignItems: 'center', fontSize: '0.78rem', cursor: 'pointer' }}
                onClick={() => {
                  rewardOverlayRef.current?.hide();
                  setIsRewardDialogOpen(false);
                  navigateToPage(MenuType.RewardDeatils);
                }}
              >
                <span style={{ color: '#333' }}>🏆 <strong>View Reward History</strong></span>
                <span style={{ color: '#6ba83e', display: 'flex', alignItems: 'center' }}>
                  <i className="pi pi-chevron-right" style={{ fontSize: '0.8rem', marginLeft: '4px' }}></i>
                </span>
              </div>
            </div>
          </>
        );

        return (
          <>
            <OverlayPanel ref={rewardOverlayRef} className="reward-overlay-panel" style={{ width: '320px', padding: 0, borderRadius: '16px', overflow: 'hidden', border: '1px solid #dcebda', boxShadow: '0 8px 30px rgba(0,0,0,0.1)' }}>
              {rewardBody}
            </OverlayPanel>

            {isMobileView && (
              <Dialog
                visible={isRewardDialogOpen}
                className="reward-dialog"
                style={{ width: "90vw", maxWidth: "340px" }}
                onHide={() => setIsRewardDialogOpen(false)}
                dismissableMask
                showHeader={false}
                contentStyle={{ padding: 0, background: "transparent", overflow: "visible" }}
              >
                <div className="executive-overlay-content">
                  <button
                    className="executive-overlay-close"
                    type="button"
                    aria-label="Close"
                    onClick={() => setIsRewardDialogOpen(false)}
                  >
                    <i className="pi pi-times" />
                  </button>
                  {rewardBody}
                </div>
              </Dialog>
            )}
          </>
        );
      })()}

      {/* WhatsApp Modal Dialog */}
      <Dialog
        header={whatsappDialogHeader}
        visible={showWhatsAppModal}
        onHide={() => setShowWhatsAppModal(false)}
        style={{ width: "28rem", maxWidth: "92vw" }}
        className="p-dialog-sm whatsapp-share-dialog"
        modal
        breakpoints={{ "960px": "90vw" }}
        footer={whatsappDialogFooter}
      >
        <div
          style={{
            padding: "0.5rem 0.25rem 0.25rem",
            display: "flex",
            flexDirection: "column",
            gap: "1rem",
          }}
        >
          <div
            style={{
              padding: "0.95rem 1rem",
              borderRadius: "1rem",
              background: "linear-gradient(135deg, #f6fff9 0%, #eefbf3 100%)",
              border: "1px solid #d5f5df",
            }}
          >
            <div
              style={{
                fontSize: "0.82rem",
                fontWeight: 700,
                color: "#15803d",
                textTransform: "uppercase",
                letterSpacing: "0.08em",
                marginBottom: "0.35rem",
              }}
            >
              Quick info
            </div>
            <div
              style={{
                fontSize: "0.92rem",
                color: "#374151",
                lineHeight: 1.5,
              }}
            >
              Enter the customer&apos;s WhatsApp number and send the brochure directly.
            </div>
          </div>

          <div>
            <label
              htmlFor="phone"
              style={{
                display: "block",
                fontSize: "0.88rem",
                fontWeight: 600,
                color: "#374151",
                marginBottom: "0.55rem",
              }}
            >
              WhatsApp number
            </label>

            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "0.65rem",
              }}
            >
              <div
                style={{
                  padding: "0.8rem 0.9rem",
                  borderRadius: "0.9rem",
                  border: "1px solid #d1d5db",
                  background: "#f9fafb",
                  fontSize: "0.92rem",
                  fontWeight: 600,
                  color: "#374151",
                  lineHeight: 1,
                }}
              >
                +91
              </div>
              <InputText
                id="phone"
                value={recipientPhone}
                onChange={(e) => setRecipientPhone(e.target.value)}
                placeholder="Enter 10-digit number"
                keyfilter="int"
                maxLength={10}
                className="p-inputtext-sm"
                style={{
                  flex: 1,
                  fontSize: "0.95rem",
                  padding: "0.8rem 0.95rem",
                  borderRadius: "0.9rem",
                  borderColor: "#d1d5db",
                }}
              />
            </div>
          </div>

          {!isUserLoggedIn && (
            <small style={{ fontSize: "0.78rem", color: "#6b7280" }}>
              This will be sent as <strong>Your friend</strong>. Log in to personalize the sender name.
            </small>
          )}
        </div>
      </Dialog>

      {/* Search Dropdown - Mobile */}
      {isHomePage && isSearchModalOpen && (
        <div className="search-dropdown-bar" ref={searchDropdownRef}>
          <div className="search-dropdown-content">
            <i className="pi pi-search search-dropdown-icon" />
            <input
              type="text"
              placeholder="Search products..."
              value={searchQuery}
              autoFocus
              onChange={(e) => {
                const query = e.target.value;
                setSearchQuery(query);
                if (query.trim()) {
                  navigate(
                    `${RouteConstant.products}?search=${encodeURIComponent(
                      query
                    )}`
                  );
                }
              }}
              onKeyDown={(e) => {
                if (e.key === "Escape") {
                  setIsSearchModalOpen(false);
                  setSearchQuery("");
                  navigate(RouteConstant.products);
                }
                // Navigate to home when search is cleared via backspace
                if (e.key === "Backspace" && searchQuery.length === 1) {
                  setTimeout(() => {
                    setSearchQuery("");
                    navigate(RouteConstant.products);
                    setIsSearchModalOpen(false);
                  }, 100);
                }
              }}
              className="search-dropdown-input"
            />
            {searchQuery && (
              <button
                className="search-dropdown-clear-btn"
                onClick={() => {
                  setSearchQuery("");
                  navigate(RouteConstant.products);
                  setIsSearchModalOpen(false);
                }}
                aria-label="Clear search"
                type="button"
              >
                <i className="pi pi-times" />
              </button>
            )}
          </div>
        </div>
      )}

      {/* Logout Confirmation Dialog */}
      <Dialog
        visible={logoutDialogVisible}
        onHide={() => setLogoutDialogVisible(false)}
        modal
        showHeader={false}
        style={{ width: "90vw", maxWidth: "400px", borderRadius: "20px" }}
        contentStyle={{
          padding: "clamp(1.5rem, 4vw, 2.5rem)",
          textAlign: "center",
          borderRadius: "20px",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: "clamp(1rem, 3vw, 1.5rem)",
          }}
        >
          {/* Icon */}
          <div
            style={{
              width: "clamp(70px, 20vw, 100px)",
              height: "clamp(70px, 20vw, 100px)",
              borderRadius: "50%",
              background: "#dee5dc",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <i
              className="pi pi-sign-out"
              style={{
                fontSize: "clamp(2rem, 6vw, 3rem)",
                color: "#45A049",
                transform: "rotate(0deg)",
              }}
            ></i>
          </div>

          {/* Title */}
          <h2
            style={{
              margin: 0,
              fontSize: "clamp(1.25rem, 4vw, 1.75rem)",
              fontWeight: 600,
              color: "#37474F",
            }}
          >
            Confirm Logout
          </h2>

          {/* Message */}
          <p
            style={{
              margin: 0,
              fontSize: "clamp(0.875rem, 3vw, 1rem)",
              color: "#37474F",
              lineHeight: "1.6",
            }}
          >
            Are you sure you want to logout?


            You will need to login again to access your account.
          </p>

          {/* Buttons */}
          <div
            style={{
              display: "flex",
              flexDirection: window.innerWidth < 400 ? "column" : "row",
              gap: "1rem",
              width: "100%",
              marginTop: "0.5rem",
            }}
          >
            <Button
              label="Cancel"
              onClick={() => setLogoutDialogVisible(false)}
              className="p-button-outlined"
              style={{
                flex: 1,
                padding: "clamp(0.5rem, 2vw, 0.75rem) clamp(1rem, 3vw, 1.5rem)",
                fontSize: "clamp(0.875rem, 3vw, 1rem)",
                fontWeight: 500,
                borderRadius: "25px",
                borderColor: "#B0BEC5",
                color: "#546E7A",
              }}
            />
            <Button
              label="Logout"
              onClick={() => {
                setLogoutDialogVisible(false);
                AuthService.logout();
                setTimeout(() => navigate(RouteConstant.login), 80);
              }}
              style={{
                flex: 1,
                padding: "clamp(0.5rem, 2vw, 0.75rem) clamp(1rem, 3vw, 1.5rem)",
                fontSize: "clamp(0.875rem, 3vw, 1rem)",
                fontWeight: 500,
                borderRadius: "25px",
                background: "#45A049",
                border: "none",
                color: "white",
              }}

            />
          </div>
        </div>
      </Dialog>
      <SideCartFlow
        isOpen={isCartPanelOpen ?? false}
        onClose={() => setIsCartPanelOpen?.(false)}
      />

      {/* News Modal Sidebar */}
      <NewsModal
        visible={newsVisible}
        onHide={handleNewsHide}
        newsItems={newsData}
        singleMode={false}
      />
      <SalesOrderingMain
        visible={showSalesDialog}
        onHide={() => setShowSalesDialog(false)}
      />
    </>
  );
});

AppTopbar.displayName = "AppTopbar";

export default AppTopbar;
